import { USERS_API_URL, AUTH_URL } from '../config/api';

export interface LoginResponse {
    firstName: string;
    lastName: string;
    role: 'user-client-buyer' | 'user-organizer';
    email: string;
}

export interface LoginRequest {
    username: string;
    password: string;
}

export interface RegisterRequest {
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    organizationName: string;
    contactNumber: string;
    role: 'user-client-buyer' | 'user-organizer';
}

export const authService = {

    async login(data: LoginRequest): Promise<LoginResponse> {
        try {
            const response = await fetch(`${AUTH_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Invalid credentials');
            }

            // Ahora sí leemos y retornamos el JSON con confianza
            return await response.json();
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },

    async logout() {
        try {
            await fetch(`${AUTH_URL}/logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
        } catch (error) {
            console.error('Error logging out in server', error);
        }
    },

    async register(data: RegisterRequest) {
        try {
            const response = await fetch(`${USERS_API_URL}/user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.message || 'Error registering the user');
            }
            return await response.json();
        } catch (error) {
            console.error('Registration error:', error);
            throw error;
        }
    }
};